import axios from 'axios';

import {eventReportQueryString} from '../utils/string';

const EVENTS = {
    LIST: 'EVENTS_LIST',
    CLEAR: 'EVENTS_CLEAR',
    PENDING: 'EVENTS_PENDING',
    ERROR: 'EVENTS_ERROR',
    CLEAR_EVENT: 'CLEAR_EVENT'
};

const initialState = {};

const eventsReducer = (state = initialState, action) => {
    switch (action.type) {
        case EVENTS.PENDING:
            return {
                ...state,
                isPending: true,
            };
        case EVENTS.LIST:
            return {
                list: action.payload,
            };
        case EVENTS.CLEAR:
            return initialState;
        case EVENTS.ERROR:
            return {
                isError: true,
            }
        default:
            return state;
    }
};

export default eventsReducer;

const setTimezone = (date) => {
    date.setTime(date.getTime());
    return date;
};


/* Загрузка списка оповещений (событий) */
export const loadEventReport = (query, pageNumber, pageSize) => dispatch => {
    let url = `/api/statistics/event-storage/events/?page=${pageNumber}&page_size=${pageSize}`;
    const dateBegin = setTimezone(query.dateBegin);
    const dateEnd = setTimezone(query.dateEnd);
    url += eventReportQueryString(query, dateBegin, dateEnd);
    dispatch({
        type: EVENTS.PENDING,
        // payload: null,
    });
    axios.get(url)
        .then(res => {
            // window.scrollTo(0, 0); // мотаю страницу на верх
            dispatch({
                type: EVENTS.LIST,
                payload: {
                    currentPage: pageNumber,
                    ...res.data,
                },
            });
        })
        .catch(e => {
            dispatch({
                type: EVENTS.ERROR,
                payload: null
            })
        })
};

export const clearEventReport = () => dispatch => {
    dispatch({
        type: EVENTS.CLEAR,
        payload: null,
    });
};
